// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.closureForm[data-v-27c96b8c] {\n  margin-bottom: 2rem;\n}\n", ""]);
// Exports
module.exports = exports;
